import React from 'react';
import PropTypes from 'prop-types';

import { Date } from 'components/utilities';

const { shape, string } = PropTypes;

const RegistrationClosed = ({ event }) => (
  <div className="account-wrapper account-wrapper-wide">

    <h3>{ _.get(event, 'name') } registration</h3>

    <div className="account-form account-body align-center">
      <div className="fs-125 m-b-1">
        Registration closed on <Date date={event.registration_closes_on} />
      </div>
    </div>
  </div>
);

RegistrationClosed.propTypes = {
  event: shape({
    registration_closes_on: string.isRequired,
  }).isRequired,
};

export default RegistrationClosed;
